export var DataFilterOperator;
(function (DataFilterOperator) {
    DataFilterOperator["AND"] = "AND";
    DataFilterOperator["OR"] = "OR";
})(DataFilterOperator || (DataFilterOperator = {}));
export var DataTypeOperator;
(function (DataTypeOperator) {
    DataTypeOperator["EXISTS"] = "EXISTS";
    DataTypeOperator["NOT_EXISTS"] = "NOT_EXISTS";
    DataTypeOperator["EQUAL"] = "EQUAL";
    DataTypeOperator["NOT_EQUAL"] = "NOT_EQUAL";
    DataTypeOperator["MORE_THAN"] = "MORE_THAN";
    DataTypeOperator["MORE_THAN_EQUAL"] = "MORE_THAN_EQUAL";
    DataTypeOperator["LESS_THAN"] = "LESS_THAN";
    DataTypeOperator["LESS_THAN_EQUAL"] = "LESS_THAN_EQUAL";
    DataTypeOperator["BETWEEN"] = "BETWEEN";
    DataTypeOperator["NOT_BETWEEN"] = "NOT_BETWEEN";
    DataTypeOperator["PERIOD_BETWEEN"] = "PERIOD_BETWEEN";
    DataTypeOperator["PERIOD_NOT_BETWEEN"] = "PERIOD_NOT_BETWEEN";
    DataTypeOperator["CONTAINS"] = "CONTAINS";
    DataTypeOperator["DOES_NOT_CONTAIN"] = "DOES_NOT_CONTAIN";
    DataTypeOperator["SIMILAR_TO"] = "SIMILAR_TO";
    DataTypeOperator["STARTS_WITH"] = "STARTS_WITH";
    DataTypeOperator["ENDS_WITH"] = "ENDS_WITH";
    DataTypeOperator["TRUE"] = "TRUE";
    DataTypeOperator["FALSE"] = "FALSE";
    DataTypeOperator["LAST"] = "LAST";
    DataTypeOperator["IN_THIS_YEAR"] = "IN_THIS_YEAR";
    DataTypeOperator["NOT_IN_THIS_YEAR"] = "NOT_IN_THIS_YEAR";
    // Date operators (Step 3.0). longValues = [lowerOffset, upperOffset] in days relative to today.
    // Either endpoint may be null/omitted to leave that side unbounded.
    DataTypeOperator["RELATIVE_DAYS_FROM_TODAY"] = "RELATIVE_DAYS_FROM_TODAY";
    DataTypeOperator["RELATIVE_DAYS_NOT_FROM_TODAY"] = "RELATIVE_DAYS_NOT_FROM_TODAY";
    // Date operators (Step 3.0). longValues = [startMonthDay, endMonthDay] where each value
    // is month*100 + day (e.g. 615 = June 15). Year-agnostic recurring window.
    DataTypeOperator["RECURRING_MONTH_BETWEEN"] = "RECURRING_MONTH_BETWEEN";
    DataTypeOperator["RECURRING_MONTH_NOT_BETWEEN"] = "RECURRING_MONTH_NOT_BETWEEN";
    DataTypeOperator["IN"] = "IN";
    DataTypeOperator["NOT_IN"] = "NOT_IN";
    // Audience reference operators (Step 2). textValues carries referenced audience ids.
    DataTypeOperator["IN_AUDIENCE"] = "IN_AUDIENCE";
    DataTypeOperator["NOT_IN_AUDIENCE"] = "NOT_IN_AUDIENCE";
    // Mailing engagement operators (Step 3d). textValues carries campaign (Maileon mailing) ids;
    // RECEIVED_CAMPAIGN_IN_LAST also carries longValues = [nDays]. Query smartData.mailingHistory.
    DataTypeOperator["OPENED_CAMPAIGN"] = "OPENED_CAMPAIGN";
    DataTypeOperator["CLICKED_CAMPAIGN"] = "CLICKED_CAMPAIGN";
    DataTypeOperator["RECEIVED_CAMPAIGN_IN_LAST"] = "RECEIVED_CAMPAIGN_IN_LAST";
})(DataTypeOperator || (DataTypeOperator = {}));
/**
 * Synthetic field key used for `IN_AUDIENCE` / `NOT_IN_AUDIENCE` rules. The backend's
 * `getFilterOptions(ProfileV3::class)` advertises this as a virtual filter option so the
 * field-picker dropdown can show "Audience" / "Zielgruppe"; the compiler ignores the field
 * path for these operators and reads referenced audience ids from `textValues`.
 */
export var AUDIENCE_REFERENCE_FIELD = 'audienceReference';
/**
 * Synthetic field key for the Step 3d mailing-engagement operators (`OPENED_CAMPAIGN`,
 * `CLICKED_CAMPAIGN`, `RECEIVED_CAMPAIGN_IN_LAST`). Backend advertises it as "Email engagement";
 * the compiler ignores the field path and reads campaign ids from `textValues`.
 */
export var MAILING_CAMPAIGN_FIELD = 'mailingCampaign';
export var DataType;
(function (DataType) {
    DataType["NUMBER"] = "NUMBER";
    DataType["DECIMAL"] = "DECIMAL";
    DataType["TEXT"] = "TEXT";
    DataType["BOOL"] = "BOOL";
    DataType["ENUM"] = "ENUM";
    DataType["LOCAL_DATE"] = "LOCAL_DATE";
    DataType["TIMESTAMP"] = "TIMESTAMP";
    DataType["COMPLEX"] = "COMPLEX";
    DataType["FUNCTIONS"] = "FUNCTIONS";
})(DataType || (DataType = {}));
